"use client";

import Check from "lucide-react/dist/esm/icons/check";
import { cn } from "@/lib/utils";
import { evaluatePasswordPolicy, PASSWORD_POLICY_LINES } from "@/lib/password-policy";

interface PasswordStrengthProps {
  password: string;
}

export default function PasswordStrength({ password }: PasswordStrengthProps) {
  const { lengthOk } = evaluatePasswordPolicy(password);
  const checks = [lengthOk] as const;

  if (!password) return null;

  return (
    <ul className="space-y-1.5 text-xs animate-fade-up" aria-label="Password requirements">
      {PASSWORD_POLICY_LINES.map((line, i) => (
        <li key={line} className="flex items-start gap-2">
          <span
            className={cn(
              "mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded border transition-colors",
              checks[i]
                ? "border-success/60 bg-success/10 text-success"
                : "border-border bg-muted/30 text-muted-foreground",
            )}
            aria-hidden
          >
            {checks[i] ? <Check className="h-3 w-3" strokeWidth={3} /> : null}
          </span>
          <span className={cn("leading-tight", checks[i] ? "text-foreground" : "text-muted-foreground")}>
            {line}
          </span>
        </li>
      ))}
    </ul>
  );
}
